export default "__VITE_ASSET__BKHChI0J__"